<template>
  <div class='tips'>
    <div class="intro-y box lg">
      <div
        class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
      >
        <h2 class="font-medium text-base mr-auto">预警提示</h2>
      </div>
        <el-tabs v-model="activeName" @tab-click="callback" :stretch = true class="istop">
          <el-tab-pane 
            :label="statu.name" 
            v-for="(statu,index) in statusList" 
            :key="index" 
            class="item">
        </el-tab-pane>
        <div
          v-infinite-scroll="handleInfiniteOnLoad"
          class="demo-infinite-container"
          :infinite-scroll-disabled="busy"
          :infinite-scroll-distance="10"
        >
          <div 
            class="intro-y item" 
            v-for="(item,index) in warnList" 
            :key="index">
            <div 
              class="box px-4 py-4 items-center zoom-in" 
              :style="{marginTop: index > 0 ? '20px' : '4px'}">
              <div class="font-medium news-content item-top">
                <div>{{item.companyName}}-{{item.typeDesc}}</div>
                <el-button size="medium" type="info" v-if="item.status=='UNTREATED'" @click="toWarnDetails(item)">去处理</el-button>
                <el-button size="medium" type="info" plain v-if="item.status=='PROCESSED'" @click="toWarnDetails(item)">已阅</el-button>
              </div>
              <div class="text-gray-600 text-xs">
                {{item.createTime}}
              </div>
              
            </div>
                        
          </div>
        </div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import infiniteScroll from 'vue-infinite-scroll';
  import {getWarnList,messageReadWarn} from '../../../api/workbench.js'
  export default {
    name: "tips",
    directives: { infiniteScroll },
    components: {},
    data() {
      return {
        activeName:0,
        statusList:[
          {name:'全部'},
          {name:'未处理'},
          {name:'已阅'},
        ],
        warnList:[],
        loading:false,
        busy: false,
        pageWarn:0,
        status:'',
      }
    },
    methods: {
      callback(key) {
        let status = ''
        if(this.activeName == '0'){
          status =''
        }else if(this.activeName == '1'){
          status ='UNTREATED'
        }else if(this.activeName == '2'){
          status ='PROCESSED'
        }
        this.status = status;
        this.pageWarn = 1
        this.warnList = []
        this.getWarnList()
      },
      toWarnDetails(params){
        if(params.status == 'UNTREATED'){
          let para = {
            id:params.id,
            status:'PROCESSED',
          }
          messageReadWarn(para).then(res => {
            let data = res.data
            if (data.code === '000') {
              
            } else {
              
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {
          })
        }
        if(params.type == 'CONTRACT'){
          this.$router.push({path:'/assetManagement/assetDetail',query:{assetId:params.primaryKey,activeKey:'contract'}})
        }else{
          this.$router.push({path:'/tenantManagement/tenantDetail',query:{broadside:params.companyName,status:1}})
        }
        
      },
      handleInfiniteOnLoad() {
        this.busy = true
        this.loading = true;
        setTimeout(() => {
          this.pageWarn++
          this.getWarnList(true)
        }, 500)
      },
      getWarnList(flag){
        let para = {
          status: this.status,
          page:this.pageWarn,
          perPage:10,
        }
        this.busy = true;
        this.loading = true;
        getWarnList(para).then(res => {
          this.loading = false
          let data = res.data
          if (data.code === '000') {
            if (flag) {
              this.warnList = this.warnList.concat(data.content.list)
              if(data.content.hasNextPage) {
                this.busy = false
              }else{
                this.busy = true
              }
            } else {
              this.warnList = data.content.list
              this.busy = false 
              if (data.content.list.length === 0 || data.content.hasNextPage === false) {
              //若无数据（接口返回list长度为0）或只有一页数据，将busy设置为true，不再执行loadMore
                this.busy = true
              }
            }
            if(data.content.allNum){
              this.$forceUpdate();
              let name = '全部(' + data.content.allNum + ')'
              this.$set(this.statusList[0],'name',name);
            }
            if(data.content.unNum){
              this.$forceUpdate();
              this.$set(this.statusList[1],"name",'未处理(' + data.content.unNum + ')');
              this.$store.commit('GET_UNTREATED',true)
            }else{
              this.$store.commit('GET_UNTREATED',false)
            }
            if(data.content.proNum){
              this.$forceUpdate();
              this.$set(this.statusList[2],"name",'已阅(' + data.content.proNum + ')');
            }
          } else {
            
          }
        }).catch(err => {
          console.log(err);
          this.loading = false
        }).finally(() => {
          this.loading = false
          this.busy = false;
        })
      },
    },
    created() {

    },
  }
</script>

<style scoped>
.istop {
  margin: 15px 24px 0 !important;
}
.demo-infinite-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
}
</style>
<style scoped lang="scss">
  .tips {
    width: 100%;
    min-height: 350px;
    .item {
      // border-top:1px solid #f0f2f5;
      // border-bottom:1px solid #f0f2f5;
      .item-top {
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
